module.exports = __webpack_public_path__ + "media/MRI18.35fbd79b.mp3";